// extracted by mini-css-extract-plugin
module.exports = {"body":"Signupstyle_body__3tGd_","form":"Signupstyle_form__2hp0Y","formlabel":"Signupstyle_formlabel__35RMx"};